import { clsx } from 'clsx'
import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../../global-config'
import { ProductPicture } from '../../../../../product'
import { TENANT } from '../../../../../tenant'
import { ProductAddToCartQuantitySelection } from '../../ProductAddToCartGroup/ProductAddToCartQuantitySelection/ProductAddToCartQuantitySelection'
import { ProductBuyBoxStickyAddToCart } from '../ProductBuyBoxStickyAddToCart'
import { ProductBuyBoxStickyPriceInfo } from '../ProductBuyBoxStickyPriceInfo.tsx'
import { ProductBuyBoxStickyProductQuantity } from '../ProductBuyBoxStickyProductQuantity'

export const ProductBuyBoxStickyDesktop: FC<{ product: PimProductV11 }> = ({
  product,
}) => {
  const { tenant } = useGlobalConfigContext()
  const hasTenantImageStyles = [TENANT.AT, TENANT.FR].includes(tenant)

  return (
    <div
      className={clsx(
        'fixed inset-x-0 bottom-0 z-10 border-t border-dark-primary-min bg-light-primary-low p-3.5 shadow-[0px_-4px_8px_0px_#0000000A]',
        hasTenantImageStyles && 'items-center justify-between gap-2.5',
      )}
      data-clientside-hook="stickyBuyBox"
    >
      <div className="container flex justify-between">
        {hasTenantImageStyles ? (
          <ProductPicture
            className="shrink-0"
            imageProps={{
              alt: product.name,
              height: 70,
              src: product.images?.at(0),
              width: 70,
            }}
          />
        ) : null}
        <div className="flex flex-col">
          <h2 className="text-m font-medium">{product.name}</h2>
          <ProductBuyBoxStickyProductQuantity />
        </div>
        {hasTenantImageStyles ? null : (
          <ProductAddToCartQuantitySelection className="ml-5 w-[108px] shrink-0" />
        )}

        <div className="grow">
          <ProductBuyBoxStickyPriceInfo />
        </div>
        <div>
          <ProductBuyBoxStickyAddToCart />
        </div>
      </div>
    </div>
  )
}
